import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useState, useEffect } from 'react';
import useClickOutside from '../../Hooks/useClickOutside';
import { mintNFTData } from '../../Shared/MintNftAndStakingNftData';

export interface INftMintProps {
}

export function NftMint(props: INftMintProps) {


    const hanldeMinMaxValue = (e: any) => {
        if (e.target.value > 5) {
            e.target.value = 5;
        }
        else if (e.target.value < 0) {
            e.target.value = 0;
        }
    }

    const handleQuantityIncrease = (index: number) => {
        const mintNFTQuantity = document.getElementById(`mintNFTQuantity${index}`) as HTMLInputElement;
        if (JSON.parse(mintNFTQuantity.value) < 5) {
            mintNFTQuantity.value = JSON.parse(mintNFTQuantity.value) + 1
        } else {
            return
        }
    }

    const handleQuantityDecrease = (index: any) => {
        const mintNFTQuantity = document.getElementById(`mintNFTQuantity${index}`) as HTMLInputElement;
        if (JSON.parse(mintNFTQuantity.value) > 0) {
            mintNFTQuantity.value = `${JSON.parse(mintNFTQuantity.value) - 1}`
        } else {
            return
        }
    }





    // details open
    const mintNftDetailsRefs = React.useRef(new Array())
    const [clickedNftDetailsIndex, setClickedNftDetailsIndex] = useState(-1)
    const [isDetailsOpen, setIsDetailsOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: mintNftDetailsRefs.current[clickedNftDetailsIndex] }, () => {
        const newVisibilities = [...isDetailsOpen];
        newVisibilities[clickedNftDetailsIndex] = false;
        setIsDetailsOpen(newVisibilities);
    })

    const hanldeNftDetailsOpenBtn = (index: any) => {
        const newVisibilities = [...isDetailsOpen];
        newVisibilities[index] = !newVisibilities[index];
        setIsDetailsOpen(newVisibilities);
        setClickedNftDetailsIndex(index)
    };

    useEffect(() => {
        const arrayData = mintNftDetailsRefs.current.map((data, index) => `${index}`)
        setIsDetailsOpen(() => arrayData.map((x) => false));
    }, [])










    return (
        <div className="nft_min_main_box mt-16 mx-auto xs:px-5 sm:px-0 pb-28
        pt-[64px]
        sm:pt-[80px] sm:max-w-[570px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px] text-left">


            <div>
                <div className="relative inline-block">
                    <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">NFT Mint</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>
                <p className="text-l-LightBlack dark:text-white mt-1 font-medium text-lg">Purchase NFTs directly.</p>
            </div>




            <div className="flex sm:flex-row flex-col justify-between items-center w-full mt-5 sm:mt-9 md:mt-14">
                <div className="bg-[#fff] dark:bg-[#232057] rounded-full p-0.5 w-full sm:w-auto filter drop-shadow-md flex justify-start items-center order-2 sm:order-1">
                    <label className="cursor-pointer w-full">
                        <input type="radio" defaultChecked name="nftMintState" id="nftMint_live" className="peer hidden" />
                        <p className="font-semibold px-7 py-2 rounded-full
                        from-[#00DBFF] via-[#E315E8] to-[#FFD817] w-full text-center
                        peer-checked:bg-gradient-to-br text-cusBlack dark:text-white peer-checked:text-white text-sm sm:text-lg">Live</p>
                    </label>

                    <label className="cursor-pointer ml-2 w-full">
                        <input type="radio" name="nftMintState" id="nftMint_finished" className="peer hidden" />
                        <p className="font-semibold px-7 py-2 rounded-full
                        from-[#00DBFF] via-[#E315E8] to-[#FFD817]  w-full text-center
                        peer-checked:bg-gradient-to-br text-cusBlack dark:text-white peer-checked:text-white text-sm sm:text-lg">Finished</p>
                    </label>
                </div>



                <div className="bg-[#fff] dark:bg-[#232057] rounded-full filter drop-shadow-md
                flex justify-start items-center order-1 sm:order-2 mb-3 sm:mb-0 w-full
                px-4 py-3.5 sm:w-auto">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20.207" height="20.207" viewBox="0 0 20.207 20.207">
                            <g id="search" transform="translate(1 1)">
                                <circle id="Oval" cx="7.908" cy="7.908" r="7.908" transform="translate(0 0)" fill="none" stroke="#c8c8c9" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                                <path id="Path" d="M4.3,4.3,0,0" transform="translate(13.493 13.493)" fill="none" stroke="#c8c8c9" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                            </g>
                        </svg>
                    </div>

                    <input
                        type="text" name="" id=""
                        placeholder="Search pools..."
                        className="bg-transparent text-xs xsm:text-sm md:text-base outline-none ml-3
                            w-full sm:w-44 sm:focus:w-60 lg:focus:w-64 xl:focus:w-80 2xl:focus:w-96 h-full
                        text-cusBlack dark:text-white transition-all duration-500" />
                </div>
            </div>





            <div className="mt-10 grid grid-cols-1 xsm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5
            gap-x-3 gap-y-6">
                {mintNFTData.map((mintNft, index) =>
                    <div
                        key={mintNft.id}
                        className="rounded-md md:rounded-lg xl:rounded-xl lightBlueBg overflow-hidden p-1.5 shadow-xl h-fit"
                    >
                        <div className="w-full
                         h-[200px] xxsm:h-[298px] xsm:h-[230px] sm:h-[268px] md:h-[308px] lg:h-[268px] xl:h-[248px] 3xl:h-[268px]
                        rounded-md md:rounded-lg xl:rounded-xl overflow-hidden group">
                            <img src={mintNft.nftImage} alt="" className="w-full h-full object-cover group-hover:scale-125 transition-all duration-300" />
                        </div>



                        <div className="mt-3 text-center px-3">
                            <h3 className="text-center font-semibold tracking-wider text-cusBlack dark:text-white
                             truncate text-lg sm:text-xl 2xl:text-2xl">{mintNft.nftTitle}</h3>

                            <p className="text-l-LightBlack dark:text-cusBlueWhite text-xxs sm:text-xs 2xl:text-sm">({mintNft.price.toFixed(2)} BNB per Item)</p>

                            <div className="flex justify-center items-start mt-2 sm:mt-3 w-8/12 mx-auto">
                                <div className="grow">
                                    <h4 className="text-2xl 2xl:text-3xl font-bold text-[#8800FF] dark:text-[#1fc7d4]">{mintNft.supply}</h4>
                                    <p className="text-xxs leading-3 sm:text-xs text-l-LightBlack dark:text-cusBlueWhite">Supply</p>
                                </div>
                                <p className="text-2xl 2xl:text-3xl grow-0 font-bold text-[#8800FF] dark:text-[#1fc7d4]">:</p>
                                <div className="grow">
                                    <h4 className="text-2xl 2xl:text-3xl font-bold text-[#8800FF] dark:text-[#1fc7d4]">{mintNft.minted}</h4>
                                    <p className="text-xxs leading-3 sm:text-xs text-l-LightBlack dark:text-cusBlueWhite">Minted</p>
                                </div>
                            </div>


                            <div className="flex justify-between items-center mt-3 h-[35px] sm:h-[40px] md:h-[45px] 2xl:h-[50px]">
                                <motion.button
                                    onClick={() => handleQuantityDecrease(index)}
                                    whileHover={{ scale: 1.1, }}
                                    whileTap={{ scale: 1 }}
                                    className="text-2xl font-bold text-white bg-[#849ABA] dark:bg-[#1fc7d4] rounded-l-full h-full px-4 select-none">
                                    -
                                </motion.button>

                                <div className=" border-t-2 border-b-2 h-full w-full border-[#849ABA] dark:border-[#1fc7d4]">
                                    <input type="number" name=""
                                        id={`mintNFTQuantity${index}`}
                                        onInput={hanldeMinMaxValue}
                                        defaultValue={0}
                                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                        className="appearance-none bg-transparent form-input outline-none border-0 text-center font-extrabold
                                    h-full w-full px-2 focus:border-[#8800FF] text-cusBlack dark:text-white text-2xl" />
                                </div>

                                <motion.button
                                    onClick={() => handleQuantityIncrease(index)}
                                    whileHover={{ scale: 1.1, }}
                                    whileTap={{ scale: 1 }}
                                    className="text-2xl font-bold text-white bg-[#849ABA] dark:bg-[#1fc7d4] rounded-r-full h-full px-4 select-none">
                                    +
                                </motion.button>
                            </div>



                            <motion.div
                                whileHover={{ scale: 1.08, }}
                                whileTap={{ scale: 1 }}
                                className="rounded-full bg-gradient-to-l p-[3px] mt-2 sm:mt-3
                            from-[#00DBFF] via-[#E315E8] to-[#FFD817]  w-full text-center">

                                <button className="w-full py-1 sm:py-1.5 md:py-2 text-cusBlack dark:text-white
                                font-semibold dark:bg-[#1d1b4b] bg-white rounded-full">
                                    Mint Now
                                </button>

                            </motion.div>




                            <div className="mt-3 sm:mt-5 pb-3"
                                ref={(el) => mintNftDetailsRefs.current[index] = el}>
                                <div className="flex justify-center items-center cursor-pointer"
                                    onClick={() => hanldeNftDetailsOpenBtn(index)}
                                >
                                    <p className="text-cusBlack dark:text-[#1fc7d4] font-bold mr-1 select-none text-sm md:text-base">
                                        {isDetailsOpen[index] ? "Hide" : "Details"}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`w-3 stroke-[#310063] dark:stroke-[#1fc7d4] ${isDetailsOpen[index] ? 'rotate-180' : ''} transition-all`} viewBox="0 0 10.18 6.09">
                                        <path id="Path" d="M0,0,3.676,3.676,7.352,0" transform="translate(1.414 1.414)" fill="none" stroke=""
                                            strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {isDetailsOpen[index] &&
                                        <motion.div
                                            initial={{ height: 0 }}
                                            animate={{ height: 'auto' }}
                                            exit={{ height: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="overflow-hidden">
                                            <div className="flex justify-between items-center mt-4">
                                                <p className="text-sm 2xl:text-base text-l-LightBlack dark:text-white font-medium">Your Balance:</p>
                                                <p className="text-sm 2xl:text-base text-l-LightBlack dark:text-white font-medium">{mintNft.yourBalance} Items(s)</p>
                                            </div>

                                            <div className="flex justify-between items-center mt-1">
                                                <p className="text-sm 2xl:text-base text-l-LightBlack dark:text-white font-medium">Max. Mint:</p>
                                                <p className="text-sm 2xl:text-base text-l-LightBlack dark:text-white font-medium">{mintNft.maxMint} Items(s)</p>
                                            </div>

                                        </motion.div>
                                    }
                                </AnimatePresence>

                            </div>



                        </div>


                    </div>
                )
                }



            </div>







        </div>
    );
}
